import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Elegant%20artistic%20portrait%20photography%20of%20beautiful%20Asian%20women%20in%20flowing%20dresses%20with%20soft%20dreamy%20lighting%20and%20ethereal%20atmosphere%2C%20fine%20art%20fashion%20editorial%20style%2C%20warm%20golden%20and%20cream%20tones%2C%20soft%20focus%20background%20with%20bokeh%20lights%2C%20elegant%20and%20romantic%20mood%2C%20high%20quality%20magazine%20photography%2C%20cinematic%20composition%20with%20negative%20space%20for%20text%20overlay&width=1920&height=1080&seq=hero-main-bg&orientation=landscape"
        alt="美女图精选合集 - 高清唯美写真欣赏"
        title="美女图精选合集 - 高清唯美写真欣赏"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4 text-center">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold font-heading text-white mb-4 tracking-wide">
          美女图精选合集
        </h1>
        <p className="text-base md:text-lg text-white/85 max-w-2xl leading-relaxed mb-8">
          汇聚高清唯美写真、时尚人像摄影与艺术风格美图，每日更新，满足你对美的一切想象
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-3">
          <Link
            to="/category/qingchun"
            className="px-8 py-3 bg-primary-500 hover:bg-primary-600 text-white font-medium rounded-full transition-all duration-300 whitespace-nowrap text-sm"
          >
            开始探索
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 bg-white/15 hover:bg-white/25 text-white font-medium rounded-full backdrop-blur-sm transition-all duration-300 whitespace-nowrap text-sm"
          >
            了解更多
          </Link>
        </div>

        <div className="flex items-center gap-6 mt-10">
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold text-white">5000+</p>
            <p className="text-xs text-white/70 mt-1">精品写真</p>
          </div>
          <div className="w-px h-8 bg-white/30"></div>
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold text-white">6</p>
            <p className="text-xs text-white/70 mt-1">风格分类</p>
          </div>
          <div className="w-px h-8 bg-white/30"></div>
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold text-white">100万+</p>
            <p className="text-xs text-white/70 mt-1">累计用户</p>
          </div>
        </div>
      </div>
    </section>
  );
}